import React from "react";
import { AQIDataItem } from "../utils/types";

interface ProgressData {
  progressWidth: string;
  progressHeight: number;
  progressColor: string;
}

const ProgressAQI: ProgressData[] = [
  { progressWidth: "10%", progressHeight: 20, progressColor: "#4CB050" },
  { progressWidth: "10%", progressHeight: 20, progressColor: "#76D60F" },
  { progressWidth: "20%", progressHeight: 20, progressColor: "#F8E70F" },
  { progressWidth: "20%", progressHeight: 20, progressColor: "#FE9900" },
  { progressWidth: "20%", progressHeight: 20, progressColor: "#FE0000" },
  { progressWidth: "20%", progressHeight: 20, progressColor: "#C00000" },
];

const AQIProgressModal: React.FC<{ data: AQIDataItem }> = ({ data }) => {
  const checkAndChangeAQIStationName = (name: string) =>
    name.length > 20 ? `${name.slice(0, 17)}...` : name;

  const width = "100%";

  return (
    <div
      style={{
        justifyContent: "center",
        alignItems: "center",
        display: "flex",
      }}
    >
      <div
        style={{
          width: 350,
          height: 120,
          backgroundColor: "#ffffff", // Replace with navbar color
          alignItems: "center",
          //   borderRadius: 15,
          //   boxShadow: "0px 8px 15px rgba(0, 0, 0, 0.2)",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* Header */}
        {/* <div
          style={
            {
              // width:,
              // borderBottom: "1px solid #EEE",
              // padding: 10,
              // display: "flex",
              // justifyContent: "space-between",
              // alignItems: "center",
            }
          }
        >
          <p
            style={{
              fontFamily: "OpenSans-Bold",
              fontSize: 15,
              //   width: "95%",
              color: "black",
            }}
          >
            {checkAndChangeAQIStationName(data.stnname)}
          </p>
        </div> */}

        {/* AQI Text */}
        <div style={{ width: "100%", marginTop: 10, textAlign: "center" }}>
          <p className="font-sans text-base font-semibold">AQI: {data.aqi}</p>
        </div>

        {/* Progress Bar */}
        <div
          style={{
            width: "90%",
            height: 30,
            marginTop: 10,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "relative",
          }}
        >
          <div
            style={{
              display: "flex",
              width: "100%",
              backgroundColor: "gray",
              borderRadius: 50,
              overflow: "hidden",
            }}
          >
            {ProgressAQI.map((bar, index) => (
              <div
                key={index}
                style={{
                  width: bar.progressWidth,
                  height: bar.progressHeight,
                  backgroundColor: bar.progressColor,
                }}
              />
            ))}
          </div>
          <div
            style={{
              width: 2,
              height: 25,
              backgroundColor: "#000",
              position: "absolute",
              top: "50%",
              left: `${(data.aqi / 500) * 100}%`,
              transform: "translate(-50%, -50%)",
            }}
          />
        </div>

        {/* AQI Scale */}
        <div
          style={{
            display: "flex",
            width: "90%",
            marginTop: 10,
            justifyContent: "space-between",
          }}
        >
          {[0, 50, 100, 200, 300, 400, 500].map((value, index) => (
            <p
              key={index}
              style={{
                fontFamily: "OpenSans-Bold",
                color: "#6B6B6B",
                fontSize: 12,
                opacity: 0.7,
                textAlign: "center",
                margin: 0,
              }}
            >
              {value}
            </p>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AQIProgressModal;
